// const BASE_URL = "http://36.155.180.178:30020/"; //接口地址
// const BASE_URL = "http://192.168.1.147:30010/"; //开发环境接口地址--峰
// const BASE_URL = "http://192.168.0.160:30010/"; //开发环境接口地址--乐
const BASE_URL = "https://sdk.richmob.cn/prod-api/"; //生产环境接口地址V2
// const BASE_URL = "http://sdktest.richmob.cn/prod-api/"; //测试环境接口地址
// const BASE_URL = "http://sdkapi.richmob.cn/"; //生产环境接口地址






const companyList = BASE_URL + 'sylas/admin/company/list'; //公司管理列表
const companyAdd = BASE_URL + 'sylas/admin/company/save'; //公司管理新增
const companyEdit = BASE_URL + 'sylas/admin/company/update'; //公司管理编辑

// 媒体管理
const mediaManage = {
	APPList: BASE_URL + 'sylas/admin/app/list', //媒体APP列表
	APPAdd: BASE_URL + 'sylas/admin/app/save', //媒体APP新增
	APPEdit: BASE_URL + 'sylas/admin/app/update', //媒体APP编辑
	APPDelete: BASE_URL + 'sylas/admin/app/delete', //媒体APP删除
	AppStatus: BASE_URL + 'sylas/admin/app/status', //媒体APP状态修改
	AppAuditStatus: BASE_URL + 'sylas/admin/app/checkStatus', //媒体APP审核状态修改
	download: BASE_URL + 'sylas/admin/app/download', //媒体APP审核资质模板下载
	platformAppAdd: BASE_URL + 'sylas/admin/platformApp/save', //媒体APP关联渠道新增
	platformAppEdit: BASE_URL + 'sylas/admin/platformApp/update', //媒体APP关联渠道编辑
	platformAppStatus: BASE_URL + 'sylas/admin/platformApp/status', //媒体APP关联渠道状态修改
}
// 媒体广告位
const mediaAd = {
	adsList: BASE_URL + 'sylas/admin/ads/listV2', //媒体广告位列表
	adsStatus: BASE_URL + 'sylas/admin/ads/status', //媒体广告位状态修改
	adsAdd: BASE_URL + 'sylas/admin/ads/save', //媒体广告位新增
	adsEdit: BASE_URL + 'sylas/admin/ads/update', //媒体广告位编辑
	adsConfigEdit: BASE_URL + 'sylas/admin/platAds/updateAndSaveV2', //媒体广告位配置编辑
	networkList: BASE_URL + 'sylas/admin/platformNetwork/list', //广告网络列表
	networkOption: BASE_URL + 'sylas/admin/platformNetwork/option', //广告网络下拉列表
	networkOptionDistinct: BASE_URL + 'sylas/admin/platformNetwork/optionDistinct', //广告网络下拉列表2
	networkAccountOption: BASE_URL + 'sylas/admin/platformNetwork/optionByPlatformId', //账号名称下拉列表
	networkSave: BASE_URL + 'sylas/admin/platformNetwork/save', //广告网络保存
	adsConfigDetial: BASE_URL + 'sylas/admin/ads/detail', //广告位配置详情
	adsConfigSave: BASE_URL + 'sylas/admin/platAds/updateAndSave', //广告位配置新增修改
	adsConfigDelete: BASE_URL + 'sylas/admin/platAds/delete', //广告位配置删除
	adsConfigQueryTime: BASE_URL + 'sylas/admin/platAds/setTimeout', //广告位配置请求时长修改
	adsConfigNetworkOptions: BASE_URL + 'sylas/admin/platformApp/appOption', //广告位配置广告网络下拉
	networkListExport: BASE_URL + 'sylas/admin/platformNetwork/export', //广告网络导出
	networkListAsync: BASE_URL + 'sylas/admin/platformProfit/auto-import', //广告网络同步报表
}
// 数据管理
const dataManage = {
	appDataList: BASE_URL + 'sylas/admin/adsTrack/appList', //应用数据列表
	appDataExport: BASE_URL + 'sylas/admin/adsTrack/appExport', //应用数据导出
	timeShareExport: BASE_URL + 'sylas/admin/adsTrack/mediaTimeSharExport', //媒体数据分时导出
	appExport: BASE_URL + 'sylas/admin/adsTrack/export', //数据展现导出
	apiReportExport: BASE_URL + 'sylas/admin/adsTrack/apiReportExport', //综合报表导出
	appImport: BASE_URL + 'sylas/admin/platformProfit/import', //数据展现导入
	channelDataList: BASE_URL + 'sylas/admin/adsTrack/channelList', //渠道收入列表
	channelExport: BASE_URL + 'sylas/admin/adsTrack/channelExport', //渠道数据导出
	mediaIncomeList: BASE_URL + 'sylas/admin/mediaProfit/list', //媒体收入列表
	mediaIncomeEdit: BASE_URL + 'sylas/admin/mediaProfit/mediaUpdate', //媒体收入编辑
	channelProfit: BASE_URL + 'sylas/admin/mediaProfit/channel-profit', //媒体收入分渠道数据
	channelProfitExport: BASE_URL + 'sylas/admin/mediaProfit/channel-profit-export', //媒体收入分渠道数据导出
	mediaIncomeAsync: BASE_URL + 'sylas/admin/mediaProfit/sync', //媒体收入同步
	mediaExport: BASE_URL + 'sylas/admin/mediaProfit/export', //媒体收入导出
	mediaImport: BASE_URL + 'sylas/admin/mediaProfit/importData', //媒体收入导出
	showDataList: BASE_URL + 'sylas/admin/adsTrack/list', //数据展现列表
	mediaTimeShar: BASE_URL + 'sylas/admin/adsTrack/mediaTimeShar', //媒体数据分时(原数据展现)
	mediaTimeSharSec: BASE_URL + 'sylas/admin/adsTrack/detailListTimeShar', //媒体数据分时(原数据展现)(二级列表)
	appDataSecList: BASE_URL + 'sylas/admin/adsTrack/detailList', //应用数据二级列表
	mediaDetailList: BASE_URL + 'sylas/admin/adsTrack/mediaDetailList', //渠道数据二级列表
	templateDownload: BASE_URL + 'sylas/admin/adsTrack/download', //渠道数据模版下载
	apiReportList: BASE_URL + 'sylas/admin/adsTrack/apiReport', //综合报表列表
	apiChart: BASE_URL + 'sylas/admin/adsTrack/apiChart', //综合报表图表
	versionStatistic: BASE_URL + 'sylas/admin/sdkVersion/stat', //SDK版本统计
	timeDataReportChart: BASE_URL + 'sylas/admin/adsTrack/apiChartSeries', //分时报表图表数据
	timeDataReportExport: BASE_URL + 'sylas/admin/adsTrack/mediaTimeRangeSharExport', //分时报表table导出
	timeDataReportExportChannel: BASE_URL + 'sylas/admin/adsTrack/channelTimeRangeSharExport', //渠道分时报表table导出
	timeDataReportList: BASE_URL + 'sylas/admin/adsTrack/mediaTimeRangeShar', //分时报表table数据列表
	timeDataReportListChannel: BASE_URL + 'sylas/admin/adsTrack/channelTimeRangeShar', //分时报表table数据列表
}
// 财务对账
const financeAccount = {
	mediaAccountList: BASE_URL + 'sylas/admin/bill/list', //媒体对账单列表
	mediaAccountSync: BASE_URL + 'sylas/admin/bill/sync', //媒体对账单同步
	createBill: BASE_URL + 'sylas/admin/bill/createBill', //生成结算单
	calculate: BASE_URL + 'sylas/admin/bill/calculate', //计算
	listFile: BASE_URL + 'sylas/admin/bill/listFile', //查看文件
	setCheck: BASE_URL + 'sylas/admin/bill/setCheck', //核对
	setRemit: BASE_URL + 'sylas/admin/bill/setRemit', //打款
}

// 审批待办
const approval = {
	companyAuditList: BASE_URL + 'sylas/admin/companyExamine/newList', //公司审核列表
	companyAuditHistoryList: BASE_URL + 'sylas/admin/companyExamine/list', //公司审核历史列表
	companyAuditStatus: BASE_URL + 'sylas/admin/companyExamine/setExamineStatus', //公司审核状态修改
	companySubmitExamine: BASE_URL + 'sylas/admin/companyExamine/submitExamine', //公司信息提交审核
	appAuditList: BASE_URL + 'sylas/admin/appExamine/newList', //APP审核列表
	appAuditHistoryList: BASE_URL + 'sylas/admin/appExamine/list', //APP审核历史列表
	appAuditStatus: BASE_URL + 'sylas/admin/appExamine/setExamineStatus', //app审核状态修改
	companyRegisterList: BASE_URL + 'sylas/admin/accountExamine/list', //公司注册列表
	companyRegisterExamine: BASE_URL + 'sylas/admin/accountExamine/setExamineStatus', //公司注册审核
}


const sdkVersion = BASE_URL + 'sylas/admin/sdkVersion/list'; //SDK版本管理列表
const sdkVersionAdd = BASE_URL + 'sylas/admin/sdkVersion/save'; //SDK版本管理新增

const adminLogin = BASE_URL + 'sylas/admin/login'; //登录
const adminUser = BASE_URL + 'sylas/admin/media-user/info'; //个人信息
const adminUserEdit = BASE_URL + 'sylas/admin/media-user'; //个人信息修改
const resetPwd = BASE_URL + 'sylas/admin/media-user/reset'; //重置密码

//账户管理
const userManage = {
	roleList: BASE_URL + 'sylas/admin/role/list', //角色列表
	roleAdd: BASE_URL + 'sylas/admin/role/add', //角色新增
	roleEdit: BASE_URL + 'sylas/admin/role/update', //角色修改
	roleDelete: BASE_URL + 'sylas/admin/role/delete', //角色删除
	menuList: BASE_URL + 'sylas/admin/menu/list', //菜单列表
	roleSelectOptions: BASE_URL + 'sylas/admin/role/optionselect', //角色下拉列表
	getRouters: BASE_URL + 'sylas/admin/media-user/getRouters', //获取路由列表
	getInfo: BASE_URL + 'sylas/admin/media-user/getInfo', //获取用户信息
	userDelete: BASE_URL + 'sylas/admin/media-user/remove', //用户删除
	userStatus: BASE_URL + 'sylas/admin/media-user/updateStatus', //用户状态
	loginout: BASE_URL + 'sylas/admin/logout', //登出
	appListOptions: BASE_URL + 'sylas/admin/app/appList', //数据权限选择列表
	
}

// 运营分析
const operationalAnalysis = {
	aggregationAnalysLinkList: BASE_URL + 'sylas/admin/sdkMaterialDpAdClickStat/list', // SDK素材DP落地页列表分页
	aggregationAnalysLinkExport: BASE_URL + 'sylas/admin/sdkMaterialDpAdClickStat/export', // SDK素材DP落地页列表导出
	budgetSourceRatio: BASE_URL + 'sylas/admin/sdkMaterialDpAdClickStat/budgetSourceRatio', // SDK素材DP预算来源占比
	budgetMapList: BASE_URL + 'sylas/admin/channelSourceMap/list', // 预算映射列表分页
	budgetMapAdd: BASE_URL + 'sylas/admin/channelSourceMap/add', // 新增预算映射
	budgetMapUpdate: BASE_URL + 'sylas/admin/channelSourceMap/update', // 修改预算映射
}

//公共模块
const common = {
	uploadFile: BASE_URL + 'sylas/admin/common/upload',//文件上传
	companyOption: BASE_URL + 'sylas/admin/company/option',//公司下拉选择列表
	companyMediumOption: BASE_URL + 'sylas/admin/media-user/option',//公司所属媒介下拉选择列表
	osOption: BASE_URL + 'sylas/admin/app/osOption',//操作系统下拉选择列表
	platformOption: BASE_URL + 'sylas/admin/platform/option',//渠道下拉选择列表
	mediaAppOption: BASE_URL + 'sylas/admin/app/option',//媒体APP下拉选择列表
	mediaAppOptionFilter: BASE_URL + 'sylas/admin/app/option/filter',//已通过媒体APP下拉选择列表
	mediaAppMarketOption: BASE_URL + 'sylas/admin/app/appMarketOption',//应用市场下拉选择列表
	adTypeOption: BASE_URL + 'sylas/admin/ads/adTypeOption',//广告类型下拉选择列表
	adStyleOption: BASE_URL + 'sylas/admin/ads/adStyleOption',//广告样式下拉选择列表
	mediaAdsOption: BASE_URL + 'sylas/admin/ads/appOption',//媒体广告位下拉选择列表
	channelAdsOption: BASE_URL + 'sylas/admin/adsOption',//渠道广告位下拉选择列表
	platAdsOption: BASE_URL + 'sylas/admin/platform/optionForPlatAds',//广告平台下拉选择列表
	sdkIntegralList: BASE_URL + 'sylas/admin/sdkAccess/list' ,//SDK版本接入文档
	homeChartsData: BASE_URL + 'sylas/admin/mediaProfit/incomeChart' ,//首页收益图表数据
	homeIncome: BASE_URL + 'sylas/admin/mediaProfit/getStatistics' ,//首页收益数据
	messageList: BASE_URL + 'sylas/admin/notice/list' ,//首页消息列表
	setReadStatus: BASE_URL + 'sylas/admin/notice/setReadStatus' ,//首页消息设置读取状态
	setAllReadStatus: BASE_URL + 'sylas/admin/notice/setAllReadStatus' ,//首页消息设置全部已读
	getFirstUnRead: BASE_URL + 'sylas/admin/notice/getFirstUnRead' ,//获取最新一条未读消息
}

const osOptions = [
	{value: 'IOS', label: 'iOS'},
	{value: 'Android', label: 'Android'}
]
const adsTypeOptions = [
	{value: 'OPEN_AD', label: '开屏广告'},
	{value: 'INTERSTITIAL_AD', label: '插屏广告'},
	{value: 'REWARD_VIDEO_AD', label: '激励视频广告'},
	{value: 'INFORMATION_AD', label: '信息流广告'},
]
const appPropertyOptions = [
	{value: 2, label: '正式'},
	{value: 1, label: '测试'}
]

export default {
    companyList,
		companyAdd,
		companyEdit,
		mediaManage,
		mediaAd,
		dataManage,
		financeAccount,
		approval,
		sdkVersion,
		sdkVersionAdd,
		adminLogin,
		adminUser,
		adminUserEdit,
		resetPwd,
		userManage,
		operationalAnalysis,
    common, // 公共接口
		osOptions,
		adsTypeOptions,
		appPropertyOptions
}
